import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";

import ICONS from "../../constants/icons";

import styles from "./productSearch.module.css";
import { useShopContext } from "../../../context/ShopContext";
import { ProductSearchProps } from "../types";

const ProductSearchActiveFilters = ({ activeFilters }: ProductSearchProps) => {
  const router = useRouter();
  const { productTags, variantOptions } = useShopContext();

  let allTags = [...(productTags || []), ...(variantOptions || [])];

  return (
    <div className={styles.filters}>
      {activeFilters.map((filter) => {
        let matchingTag = allTags.find((tag) => tag.slug === filter);

        if (matchingTag) {
          return (
            <Link href="/collection">
              <a
                onClick={(ev) => {
                  ev.preventDefault();

                  let searchParams = { ...router.query };
                  // Make sure it's a array
                  searchParams.q =
                    typeof searchParams.q === "string"
                      ? [searchParams.q]
                      : searchParams.q;

                  searchParams.q = searchParams.q.filter(
                    (filterItm) => filterItm !== matchingTag.slug
                  );

                  router.query = searchParams;

                  router.push(router, undefined, {
                    shallow: true,
                    scroll: false,
                  });
                }}
                className={styles.tag}
              >
                {matchingTag.name} <ICONS.CLOSE size={16} />
              </a>
            </Link>
          );
        } else {
          return <></>;
        }
      })}
      {activeFilters.length > 0 && (
        <Link href="/collection/" shallow>
          <a className={styles.clear}>Clear all</a>
        </Link>
      )}
    </div>
  );
};

export default ProductSearchActiveFilters;
